import { useRef, useState, useEffect } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";

// Textarea with a "done" checkmark while typing — tapping it saves and closes the keypad
export function NoteArea({ className = "", testId, onFocus, onBlur, disabled, maxLength = 300, onChange, ...props }) {
  const ref = useRef(null);
  const [focused, setFocused] = useState(false);
  const autoSize = () => {
    const el = ref.current;
    if (el) { el.style.height = "auto"; el.style.height = `${el.scrollHeight}px`; }
  };
  useEffect(() => { autoSize(); });
  const lastLineWarn = useRef(0);
  const handleChange = (e) => {
    const lines = e.target.value.split("\n");
    if (lines.length > 12) {
      e.target.value = lines.slice(0, 12).join("\n");
      const n = Date.now();
      if (n - lastLineWarn.current > 1200) { toast.error("Max Characters"); lastLineWarn.current = n; }
    }
    onChange && onChange(e);
  };
  return (
    <div className="relative">
      <Textarea
        ref={ref}
        disabled={disabled}
        maxLength={maxLength}
        {...props}
        onChange={handleChange}
        className={`${className} pr-9 overflow-hidden`}
        onInput={autoSize}
        onFocus={(e) => { setFocused(true); onFocus && onFocus(e); }}
        onBlur={(e) => { setFocused(false); autoSize(); onBlur && onBlur(e); }}
        data-testid={testId}
      />
      {focused && !disabled && (
        <button
          type="button"
          title="Done"
          onPointerDown={(e) => {
            e.preventDefault();
            const swallow = (ev) => { ev.stopPropagation(); ev.preventDefault(); };
            document.addEventListener("click", swallow, { capture: true, once: true });
            setTimeout(() => document.removeEventListener("click", swallow, { capture: true }), 400);
            ref.current?.blur();
          }}
          className="absolute top-1 right-1 p-1.5 bg-zinc-700 text-white hover:bg-zinc-800 transition-colors"
          data-testid={testId ? `${testId}-done` : "note-done-btn"}
        >
          <Check className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
